export default function Cancelled() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100dvh",
        backgroundColor: "#f3f4f6",
        padding: "0 24px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "32px",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          maxWidth: "400px",
        }}
      >
        <div
          style={{ color: "#ef4444", fontSize: "64px", marginBottom: "16px" }}
        >
          &#10007;
        </div>
        <h1 style={{ fontSize: "24px", fontWeight: "bold", marginTop: "16px" }}>
          Transaction Canceled
        </h1>
        <p style={{ color: "#6b7280", marginTop: "8px" }}>
          You have canceled the wallet top-up transaction.
        </p>
        <p style={{ color: "#6b7280", marginTop: "16px", fontWeight: "bold" }}>
          You may close this tab or try again.
        </p>
      </div>
    </div>
  );
}
